<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-inbox`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 012 2v36a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h36zM8 40h32V30h-4v4a2 2 0 01-2 2H14a2 2 0 01-2-2v-4H8v10zM40 8H8v18h6a2 2 0 012 2v4h16v-4a2 2 0 012-2h6V8z"/></svg>
</template>
<script>

export default {
  name: 'IconInbox',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
